import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Editor} from '../editor-components';
import ShowbagBackground from './showbag-background';
import ShowbagContents from './showbag-contents';

export default class ShowbagEditor extends Component {
  constructor(props) {
    super(props);
    const expoID = props.match.params.expoID
    const showID = props.match.params.showID
    this.state = {
      expoID: expoID,
      showID: showID
    }
    this.dataURL = `/expos/${expoID}/shows/${showID}/showbag`;
  }
  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Background</Tab>
            <Tab>Initial Contents</Tab>
          </TabList>
          <TabPanel>
            <ShowbagBackground dataURL={this.dataURL} />
          </TabPanel>
          <TabPanel>
            <ShowbagContents dataURL={this.dataURL} expoID={this.state.expoID} showID={this.state.showID}/>
          </TabPanel>
        </Tabs>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/showbag-editor/showbag-editor.js